import React from 'react';
import { NavListItemLink } from '../common/NavListItemLink';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SystemSetupSmtp } from './SystemSetupSmtp';
import { SystemSetupTask } from './SystemSetupTask';
import { SystemSetupIngress } from './SystemSetupIngress';
import { SystemSetupFilestore } from './SystemSetupFilestore';
import { SystemSetupLoghub } from './SystemSetupLoghub';
import { SystemSetupCassandra } from './SystemSetupCassandra';
import { SystemSetupTrustedCertificates } from './SystemSetupTrustedCertificates';
import { SystemSetupTrustedCertificatesNew } from './SystemSetupTrustedCertificatesNew';

export const SystemSetupInfra = () => (
  <>
    <ul className="nav nav-tabs">
      <NavListItemLink to="/system/setup/infra/task">Task</NavListItemLink>
      <NavListItemLink to="/system/setup/infra/smtp">SMTP</NavListItemLink>
      <NavListItemLink to="/system/setup/infra/ingress">
        Ingress
      </NavListItemLink>
      <NavListItemLink to="/system/setup/infra/certs">
        Trusted Certificates
      </NavListItemLink>
      <NavListItemLink to="/system/setup/infra/filestore">
        Filestore
      </NavListItemLink>
      <NavListItemLink to="/system/setup/infra/loghub">Loghub</NavListItemLink>
      <NavListItemLink to="/system/setup/infra/cassandra">
        Cassandra
      </NavListItemLink>
    </ul>
    <Routes>
      <Route path="" element={<Navigate to="task" replace />} />
      <Route path="task" element={<SystemSetupTask />} />
      <Route path="smtp" element={<SystemSetupSmtp />} />
      <Route path="ingress" element={<SystemSetupIngress />} />
      <Route path="certs" element={<SystemSetupTrustedCertificates />} />
      <Route path="certs/new" element={<SystemSetupTrustedCertificatesNew />} />
      <Route path="filestore" element={<SystemSetupFilestore />} />
      <Route path="loghub" element={<SystemSetupLoghub />} />
      <Route path="cassandra" element={<SystemSetupCassandra />} />
    </Routes>
  </>
);
